var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donations-show"},[_c('Embed',{attrs:{"fdsData":_vm.fdsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }